/**
 * @generated SignedSource<<8f009c6ee1d00cf0f7f9105f632f1934>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useDefaultSourceOfFundsQuery$variables = {
  fiatCurrency: string;
  skipAccountByUuid: boolean;
  skipAssetByUuid: boolean;
  transactionUuid?: string | null;
  uuid: string;
};
export type useDefaultSourceOfFundsQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"useDefaultSourceOfFundsViewerFragment">;
  };
};
export type useDefaultSourceOfFundsQuery = {
  response: useDefaultSourceOfFundsQuery$data;
  variables: useDefaultSourceOfFundsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fiatCurrency"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipAccountByUuid"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipAssetByUuid"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "transactionUuid"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uuid"
},
v5 = [
  (v0/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/)
],
v6 = {
  "kind": "Variable",
  "name": "transactionUuid",
  "variableName": "transactionUuid"
},
v7 = [
  {
    "kind": "Literal",
    "name": "supportedSourcesOfFunds",
    "value": [
      "PAYMENT_METHOD",
      "FIAT_WALLET",
      "CRYPTO_ACCOUNT"
    ]
  },
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEnabled",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "TradeAllowance",
  "kind": "LinkedField",
  "name": "tradeCapabilities",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowBuy",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verified",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryBuy",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v16 = [
  (v15/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expiresAt",
  "storageKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    (v17/*: any*/)
  ],
  "type": "WorldpayCardPickerData",
  "abstractKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "instantBuy",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "use3ds",
  "storageKey": null
},
v21 = {
  "kind": "InlineDataFragmentSpread",
  "name": "getIsCountryAllowedFiatFragment",
  "selections": [
    (v13/*: any*/),
    (v19/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "pickerData",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v20/*: any*/)
          ],
          "type": "WorldpayCardPickerData",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v22 = [
  (v12/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "Amount",
  "kind": "LinkedField",
  "name": "availableBalance",
  "plural": false,
  "selections": [
    (v23/*: any*/)
  ],
  "storageKey": null
},
v25 = [
  (v23/*: any*/),
  (v15/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Amount",
  "kind": "LinkedField",
  "name": "availableToSendBalance",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetBalanceBreakdown",
  "kind": "LinkedField",
  "name": "assetBalanceBreakdown",
  "plural": false,
  "selections": [
    (v26/*: any*/)
  ],
  "storageKey": null
},
v28 = {
  "kind": "InlineFragment",
  "selections": [
    (v27/*: any*/)
  ],
  "type": "ViewerAsset",
  "abstractKey": null
},
v29 = {
  "kind": "InlineDataFragmentSpread",
  "name": "readAccountBalanceFragment",
  "selections": [
    (v24/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "assetOrFiatCurrency",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v13/*: any*/),
            (v27/*: any*/)
          ],
          "type": "TiersCurrency",
          "abstractKey": null
        },
        (v28/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v30 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Asset",
      "kind": "LinkedField",
      "name": "asset",
      "plural": false,
      "selections": (v22/*: any*/),
      "storageKey": null
    }
  ],
  "type": "ViewerAsset",
  "abstractKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "assetOrFiatCurrency",
  "plural": false,
  "selections": [
    (v30/*: any*/)
  ],
  "storageKey": null
},
v32 = {
  "kind": "InlineDataFragmentSpread",
  "name": "getIsCountryAllowedAccountFragment",
  "selections": [
    (v13/*: any*/)
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "Amount",
  "kind": "LinkedField",
  "name": "availableToSendBalanceFiat",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": null
},
v34 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AssetBalanceBreakdown",
    "kind": "LinkedField",
    "name": "assetBalanceBreakdown",
    "plural": false,
    "selections": [
      (v33/*: any*/)
    ],
    "storageKey": null
  }
],
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v38 = {
  "kind": "InlineDataFragmentSpread",
  "name": "readCryptoAccountFragment",
  "selections": [
    (v32/*: any*/),
    (v29/*: any*/),
    {
      "kind": "InlineDataFragmentSpread",
      "name": "readAccountBalanceFiatFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "assetOrFiatCurrency",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v34/*: any*/),
              "type": "TiersCurrency",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v34/*: any*/),
              "type": "ViewerAsset",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": ([]/*: any*/)
    },
    (v12/*: any*/),
    (v35/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "assetOrFiatCurrency",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Asset",
              "kind": "LinkedField",
              "name": "asset",
              "plural": false,
              "selections": [
                (v12/*: any*/),
                (v36/*: any*/),
                (v35/*: any*/),
                (v37/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "ViewerAsset",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v35/*: any*/)
          ],
          "type": "TiersCurrency",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v39 = [
  (v38/*: any*/)
],
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "Amount",
  "kind": "LinkedField",
  "name": "remainingAvailableLimit",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v23/*: any*/)
  ],
  "storageKey": null
},
v41 = {
  "alias": "paymentMethodName",
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v42 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountNumber",
      "storageKey": null
    }
  ],
  "type": "BankPickerDataV2",
  "abstractKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "institutionName",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bin",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cardLast4",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requires3dsDdc",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "Amount",
  "kind": "LinkedField",
  "name": "remainingAvailableLimit",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v50 = {
  "kind": "InlineDataFragmentSpread",
  "name": "readFiatWalletAccountFragment",
  "selections": [
    (v32/*: any*/),
    (v29/*: any*/),
    (v12/*: any*/),
    (v35/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "assetOrFiatCurrency",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v49/*: any*/),
            (v35/*: any*/),
            (v13/*: any*/)
          ],
          "type": "TiersCurrency",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "PaymentLimits",
  "kind": "LinkedField",
  "name": "limits",
  "plural": false,
  "selections": [
    (v47/*: any*/)
  ],
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "Amount",
  "kind": "LinkedField",
  "name": "availableBalanceInNativeCurrency",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v53 = {
  "kind": "Variable",
  "name": "uuid",
  "variableName": "uuid"
},
v54 = [
  (v53/*: any*/)
],
v55 = [
  {
    "kind": "Variable",
    "name": "quoteCurrency",
    "variableName": "fiatCurrency"
  }
],
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v58 = [
  (v57/*: any*/)
],
v59 = {
  "kind": "InlineFragment",
  "selections": (v58/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v60 = {
  "kind": "InlineFragment",
  "selections": (v58/*: any*/),
  "type": "ViewerEquity",
  "abstractKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetBalanceBreakdown",
  "kind": "LinkedField",
  "name": "assetBalanceBreakdown",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    (v33/*: any*/)
  ],
  "storageKey": null
},
v62 = {
  "kind": "InlineFragment",
  "selections": [
    (v13/*: any*/),
    (v61/*: any*/),
    (v57/*: any*/),
    (v35/*: any*/)
  ],
  "type": "TiersCurrency",
  "abstractKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "asset",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v57/*: any*/),
    (v36/*: any*/),
    (v35/*: any*/),
    (v37/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v5/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDefaultSourceOfFundsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Viewer",
          "kind": "LinkedField",
          "name": "viewer",
          "plural": false,
          "selections": [
            {
              "kind": "InlineDataFragmentSpread",
              "name": "useDefaultSourceOfFundsViewerFragment",
              "selections": [
                {
                  "alias": null,
                  "args": (v7/*: any*/),
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "cbPaySourcesOfFunds",
                  "plural": true,
                  "selections": [
                    (v8/*: any*/),
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "readPrimaryPaymentMethodSoFFragment",
                      "selections": [
                        (v8/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v9/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PaymentMethodV2",
                              "kind": "LinkedField",
                              "name": "paymentMethod",
                              "plural": false,
                              "selections": [
                                (v10/*: any*/),
                                (v11/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": null,
                                  "kind": "LinkedField",
                                  "name": "pickerData",
                                  "plural": false,
                                  "selections": [
                                    (v8/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                {
                                  "kind": "InlineDataFragmentSpread",
                                  "name": "readPrimaryPaymentMethodFragment",
                                  "selections": [
                                    (v12/*: any*/),
                                    (v13/*: any*/),
                                    (v14/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "PaymentLimits",
                                      "kind": "LinkedField",
                                      "name": "limits",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "Amount",
                                          "kind": "LinkedField",
                                          "name": "remainingAvailableLimit",
                                          "plural": false,
                                          "selections": (v16/*: any*/),
                                          "storageKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": null,
                                      "kind": "LinkedField",
                                      "name": "pickerData",
                                      "plural": false,
                                      "selections": [
                                        (v8/*: any*/),
                                        (v18/*: any*/)
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "args": null,
                                  "argumentDefinitions": []
                                },
                                (v21/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "type": "CBPaySourceOfFundsPaymentMethod",
                          "abstractKey": null
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "readPrimaryFiatWalletFragment",
                      "selections": [
                        (v8/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v9/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PaymentMethodV2",
                              "kind": "LinkedField",
                              "name": "paymentMethod",
                              "plural": false,
                              "selections": (v22/*: any*/),
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Account",
                              "kind": "LinkedField",
                              "name": "account",
                              "plural": false,
                              "selections": [
                                (v29/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "type": "CBPaySourceOfFundsFiatWallet",
                          "abstractKey": null
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "readPrimaryCryptoAccountFragment",
                      "selections": [
                        (v8/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Account",
                              "kind": "LinkedField",
                              "name": "account",
                              "plural": false,
                              "selections": [
                                (v29/*: any*/),
                                (v31/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "type": "CBPaySourceOfFundsCryptoAccount",
                          "abstractKey": null
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Account",
                          "kind": "LinkedField",
                          "name": "account",
                          "plural": false,
                          "selections": (v39/*: any*/),
                          "storageKey": null
                        },
                        (v40/*: any*/)
                      ],
                      "type": "CBPaySourceOfFundsCryptoAccount",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v9/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "PaymentMethodV2",
                          "kind": "LinkedField",
                          "name": "paymentMethod",
                          "plural": false,
                          "selections": [
                            (v12/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": null,
                              "kind": "LinkedField",
                              "name": "pickerData",
                              "plural": false,
                              "selections": [
                                (v18/*: any*/)
                              ],
                              "storageKey": null
                            },
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "readPaymentMethodFragment",
                              "selections": [
                                (v12/*: any*/),
                                (v13/*: any*/),
                                (v41/*: any*/),
                                (v23/*: any*/),
                                (v11/*: any*/),
                                (v10/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": null,
                                  "kind": "LinkedField",
                                  "name": "pickerData",
                                  "plural": false,
                                  "selections": [
                                    (v8/*: any*/),
                                    (v42/*: any*/),
                                    {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        (v43/*: any*/),
                                        (v44/*: any*/),
                                        (v45/*: any*/),
                                        (v20/*: any*/),
                                        (v46/*: any*/),
                                        (v17/*: any*/)
                                      ],
                                      "type": "WorldpayCardPickerData",
                                      "abstractKey": null
                                    }
                                  ],
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "PaymentLimits",
                                  "kind": "LinkedField",
                                  "name": "limits",
                                  "plural": false,
                                  "selections": [
                                    (v47/*: any*/),
                                    (v48/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                (v21/*: any*/)
                              ],
                              "args": null,
                              "argumentDefinitions": []
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "type": "CBPaySourceOfFundsPaymentMethod",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Account",
                          "kind": "LinkedField",
                          "name": "account",
                          "plural": false,
                          "selections": [
                            (v50/*: any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "PaymentMethodV2",
                          "kind": "LinkedField",
                          "name": "paymentMethod",
                          "plural": false,
                          "selections": [
                            (v12/*: any*/),
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "readFiatWalletPaymentMethodFragment",
                              "selections": [
                                (v12/*: any*/),
                                (v35/*: any*/),
                                (v13/*: any*/),
                                (v23/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": null,
                                  "kind": "LinkedField",
                                  "name": "pickerData",
                                  "plural": false,
                                  "selections": [
                                    (v8/*: any*/),
                                    {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "PaymentMethodFiatAccount",
                                          "kind": "LinkedField",
                                          "name": "fiatAccount",
                                          "plural": false,
                                          "selections": (v22/*: any*/),
                                          "storageKey": null
                                        }
                                      ],
                                      "type": "CoinbaseFiatAccountPickerData",
                                      "abstractKey": null
                                    }
                                  ],
                                  "storageKey": null
                                },
                                (v51/*: any*/)
                              ],
                              "args": null,
                              "argumentDefinitions": []
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "type": "CBPaySourceOfFundsFiatWallet",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountConnection",
                  "kind": "LinkedField",
                  "name": "accountsV2",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Account",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v12/*: any*/),
                            (v31/*: any*/),
                            (v38/*: any*/),
                            (v50/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "readPrimaryCryptoAccountFromAccountsV2",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountConnection",
                      "kind": "LinkedField",
                      "name": "accountsV2",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AccountEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Account",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v13/*: any*/),
                                (v12/*: any*/),
                                (v52/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": null,
                                  "kind": "LinkedField",
                                  "name": "assetOrFiatCurrency",
                                  "plural": false,
                                  "selections": [
                                    (v8/*: any*/),
                                    (v30/*: any*/)
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": []
                },
                {
                  "condition": "skipAccountByUuid",
                  "kind": "Condition",
                  "passingValue": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": (v54/*: any*/),
                      "concreteType": "Account",
                      "kind": "LinkedField",
                      "name": "accountByUuid",
                      "plural": false,
                      "selections": (v39/*: any*/),
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "skipAssetByUuid",
                  "kind": "Condition",
                  "passingValue": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": (v54/*: any*/),
                      "concreteType": "ViewerAsset",
                      "kind": "LinkedField",
                      "name": "assetByUuid",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Asset",
                          "kind": "LinkedField",
                          "name": "asset",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": (v55/*: any*/),
                              "concreteType": "LatestAssetPrice",
                              "kind": "LinkedField",
                              "name": "latestPrice",
                              "plural": false,
                              "selections": [
                                (v56/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ]
                }
              ],
              "args": [
                {
                  "kind": "Variable",
                  "name": "fiatCurrency",
                  "variableName": "fiatCurrency"
                },
                {
                  "kind": "Variable",
                  "name": "skipAccountByUuid",
                  "variableName": "skipAccountByUuid"
                },
                {
                  "kind": "Variable",
                  "name": "skipAssetByUuid",
                  "variableName": "skipAssetByUuid"
                },
                (v6/*: any*/),
                (v53/*: any*/)
              ],
              "argumentDefinitions": (v5/*: any*/)
            }
          ],
          "storageKey": null
        },
        "action": "THROW",
        "path": "viewer"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useDefaultSourceOfFundsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "cbPaySourcesOfFunds",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isCBPaySourceOfFunds"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentMethodV2",
                    "kind": "LinkedField",
                    "name": "paymentMethod",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PaymentLimits",
                        "kind": "LinkedField",
                        "name": "limits",
                        "plural": false,
                        "selections": [
                          (v40/*: any*/),
                          (v48/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "pickerData",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v17/*: any*/),
                              (v20/*: any*/),
                              (v43/*: any*/),
                              (v44/*: any*/),
                              (v45/*: any*/),
                              (v46/*: any*/)
                            ],
                            "type": "WorldpayCardPickerData",
                            "abstractKey": null
                          },
                          (v42/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v19/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v57/*: any*/),
                      (v41/*: any*/),
                      (v23/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "CBPaySourceOfFundsPaymentMethod",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentMethodV2",
                    "kind": "LinkedField",
                    "name": "paymentMethod",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v57/*: any*/),
                      (v35/*: any*/),
                      (v13/*: any*/),
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "pickerData",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PaymentMethodFiatAccount",
                                "kind": "LinkedField",
                                "name": "fiatAccount",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v57/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "CoinbaseFiatAccountPickerData",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v51/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "assetOrFiatCurrency",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v13/*: any*/),
                              (v27/*: any*/),
                              (v57/*: any*/),
                              (v49/*: any*/),
                              (v35/*: any*/)
                            ],
                            "type": "TiersCurrency",
                            "abstractKey": null
                          },
                          (v28/*: any*/),
                          (v59/*: any*/),
                          (v60/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v57/*: any*/),
                      (v13/*: any*/),
                      (v12/*: any*/),
                      (v35/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "CBPaySourceOfFundsFiatWallet",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "assetOrFiatCurrency",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v62/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v61/*: any*/),
                              (v63/*: any*/)
                            ],
                            "type": "ViewerAsset",
                            "abstractKey": null
                          },
                          (v59/*: any*/),
                          (v60/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v57/*: any*/),
                      (v13/*: any*/),
                      (v12/*: any*/),
                      (v35/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v40/*: any*/)
                ],
                "type": "CBPaySourceOfFundsCryptoAccount",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountConnection",
            "kind": "LinkedField",
            "name": "accountsV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v12/*: any*/),
                      (v52/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "assetOrFiatCurrency",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v63/*: any*/),
                              (v61/*: any*/)
                            ],
                            "type": "ViewerAsset",
                            "abstractKey": null
                          },
                          (v59/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v57/*: any*/),
                              (v13/*: any*/),
                              (v61/*: any*/),
                              (v35/*: any*/),
                              (v49/*: any*/)
                            ],
                            "type": "TiersCurrency",
                            "abstractKey": null
                          },
                          (v60/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v57/*: any*/),
                      (v24/*: any*/),
                      (v35/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v57/*: any*/),
          {
            "condition": "skipAccountByUuid",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": (v54/*: any*/),
                "concreteType": "Account",
                "kind": "LinkedField",
                "name": "accountByUuid",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "assetOrFiatCurrency",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v62/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v61/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "asset",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v36/*: any*/),
                              (v35/*: any*/),
                              (v37/*: any*/),
                              (v57/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ViewerAsset",
                        "abstractKey": null
                      },
                      (v59/*: any*/),
                      (v60/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  (v35/*: any*/),
                  (v57/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "skipAssetByUuid",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": (v54/*: any*/),
                "concreteType": "ViewerAsset",
                "kind": "LinkedField",
                "name": "assetByUuid",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Asset",
                    "kind": "LinkedField",
                    "name": "asset",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v55/*: any*/),
                        "concreteType": "LatestAssetPrice",
                        "kind": "LinkedField",
                        "name": "latestPrice",
                        "plural": false,
                        "selections": [
                          (v56/*: any*/),
                          (v57/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v57/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v57/*: any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5ae034fc84a649169346602f099f2342",
    "id": null,
    "metadata": {},
    "name": "useDefaultSourceOfFundsQuery",
    "operationKind": "query",
    "text": "query useDefaultSourceOfFundsQuery(\n  $transactionUuid: Uuid\n  $uuid: Uuid!\n  $skipAccountByUuid: Boolean!\n  $fiatCurrency: TickerSymbol!\n  $skipAssetByUuid: Boolean!\n) {\n  viewer {\n    ...useDefaultSourceOfFundsViewerFragment_HpAvR\n    id\n  }\n}\n\nfragment getIsCountryAllowedAccountFragment on Account {\n  type\n}\n\nfragment getIsCountryAllowedFiatFragment on PaymentMethodV2 {\n  type\n  instantBuy\n  pickerData {\n    __typename\n    ... on WorldpayCardPickerData {\n      use3ds\n    }\n    ... on BankPickerDataV2 {\n      __typename\n    }\n  }\n}\n\nfragment readAccountBalanceFiatFragment on Account {\n  assetOrFiatCurrency {\n    __typename\n    ... on TiersCurrency {\n      assetBalanceBreakdown {\n        availableToSendBalanceFiat {\n          currency\n          value\n        }\n      }\n      id\n    }\n    ... on ViewerAsset {\n      assetBalanceBreakdown {\n        availableToSendBalanceFiat {\n          currency\n          value\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readAccountBalanceFragment on Account {\n  availableBalance {\n    currency\n  }\n  assetOrFiatCurrency {\n    __typename\n    ... on TiersCurrency {\n      type\n      assetBalanceBreakdown {\n        availableToSendBalance {\n          currency\n          value\n        }\n      }\n      id\n    }\n    ... on ViewerAsset {\n      assetBalanceBreakdown {\n        availableToSendBalance {\n          currency\n          value\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readCryptoAccountFragment on Account {\n  ...getIsCountryAllowedAccountFragment\n  ...readAccountBalanceFragment\n  ...readAccountBalanceFiatFragment\n  uuid\n  name\n  assetOrFiatCurrency {\n    __typename\n    ... on ViewerAsset {\n      asset {\n        uuid\n        symbol\n        name\n        imageUrl\n        id\n      }\n    }\n    ... on TiersCurrency {\n      name\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readFiatWalletAccountFragment on Account {\n  ...getIsCountryAllowedAccountFragment\n  ...readAccountBalanceFragment\n  uuid\n  name\n  type\n  assetOrFiatCurrency {\n    __typename\n    ... on TiersCurrency {\n      code\n      name\n      type\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readFiatWalletPaymentMethodFragment on PaymentMethodV2 {\n  uuid\n  name\n  type\n  currency\n  pickerData {\n    __typename\n    ... on CoinbaseFiatAccountPickerData {\n      fiatAccount {\n        uuid\n        id\n      }\n    }\n  }\n  limits {\n    remainingAvailableLimit {\n      currency\n      value\n    }\n  }\n}\n\nfragment readPaymentMethodFragment on PaymentMethodV2 {\n  ...getIsCountryAllowedFiatFragment\n  uuid\n  type\n  paymentMethodName: name\n  currency\n  verified\n  tradeCapabilities {\n    allowBuy\n  }\n  pickerData {\n    __typename\n    ... on BankPickerDataV2 {\n      accountName\n      accountNumber\n    }\n    ... on WorldpayCardPickerData {\n      institutionName\n      bin\n      cardLast4\n      use3ds\n      requires3dsDdc\n      expiresAt\n    }\n    ... on CoinbaseFiatAccountPickerData {\n      __typename\n    }\n  }\n  limits {\n    remainingAvailableLimit {\n      currency\n      value\n    }\n    description\n  }\n}\n\nfragment readPrimaryCryptoAccountFragment on CBPaySourceOfFunds {\n  __isCBPaySourceOfFunds: __typename\n  __typename\n  ... on CBPaySourceOfFundsCryptoAccount {\n    account {\n      ...readAccountBalanceFragment\n      assetOrFiatCurrency {\n        __typename\n        ... on ViewerAsset {\n          asset {\n            uuid\n            id\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        ... on TiersCurrency {\n          id\n        }\n        ... on ViewerEquity {\n          id\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment readPrimaryCryptoAccountFromAccountsV2 on Viewer {\n  accountsV2 {\n    edges {\n      node {\n        type\n        uuid\n        availableBalanceInNativeCurrency {\n          value\n        }\n        assetOrFiatCurrency {\n          __typename\n          ... on ViewerAsset {\n            asset {\n              uuid\n              id\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n          ... on TiersCurrency {\n            id\n          }\n          ... on ViewerEquity {\n            id\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment readPrimaryFiatWalletFragment on CBPaySourceOfFunds {\n  __isCBPaySourceOfFunds: __typename\n  __typename\n  ... on CBPaySourceOfFundsFiatWallet {\n    isEnabled\n    paymentMethod {\n      uuid\n      id\n    }\n    account {\n      ...readAccountBalanceFragment\n      id\n    }\n  }\n}\n\nfragment readPrimaryPaymentMethodFragment on PaymentMethodV2 {\n  uuid\n  type\n  primaryBuy\n  limits {\n    remainingAvailableLimit {\n      value\n    }\n  }\n  pickerData {\n    __typename\n    ... on WorldpayCardPickerData {\n      expiresAt\n    }\n  }\n}\n\nfragment readPrimaryPaymentMethodSoFFragment on CBPaySourceOfFunds {\n  __isCBPaySourceOfFunds: __typename\n  __typename\n  ... on CBPaySourceOfFundsPaymentMethod {\n    isEnabled\n    paymentMethod {\n      ...readPrimaryPaymentMethodFragment\n      ...getIsCountryAllowedFiatFragment\n      tradeCapabilities {\n        allowBuy\n      }\n      verified\n      pickerData {\n        __typename\n      }\n      id\n    }\n  }\n}\n\nfragment useDefaultSourceOfFundsViewerFragment_HpAvR on Viewer {\n  cbPaySourcesOfFunds(transactionUuid: $transactionUuid, supportedSourcesOfFunds: [\"PAYMENT_METHOD\", \"FIAT_WALLET\", \"CRYPTO_ACCOUNT\"]) {\n    __typename\n    ...readPrimaryPaymentMethodSoFFragment\n    ...readPrimaryFiatWalletFragment\n    ...readPrimaryCryptoAccountFragment\n    ... on CBPaySourceOfFundsCryptoAccount {\n      account {\n        ...readCryptoAccountFragment\n        id\n      }\n      remainingAvailableLimit {\n        value\n        currency\n      }\n    }\n    ... on CBPaySourceOfFundsPaymentMethod {\n      isEnabled\n      paymentMethod {\n        uuid\n        pickerData {\n          __typename\n          ... on WorldpayCardPickerData {\n            expiresAt\n          }\n        }\n        ...readPaymentMethodFragment\n        id\n      }\n    }\n    ... on CBPaySourceOfFundsFiatWallet {\n      account {\n        ...readFiatWalletAccountFragment\n        id\n      }\n      paymentMethod {\n        uuid\n        ...readFiatWalletPaymentMethodFragment\n        id\n      }\n    }\n  }\n  ...readPrimaryCryptoAccountFromAccountsV2\n  accountsV2 {\n    edges {\n      node {\n        uuid\n        assetOrFiatCurrency {\n          __typename\n          ... on ViewerAsset {\n            asset {\n              uuid\n              id\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n          ... on TiersCurrency {\n            id\n          }\n          ... on ViewerEquity {\n            id\n          }\n        }\n        ...readCryptoAccountFragment\n        ...readFiatWalletAccountFragment\n        id\n      }\n    }\n  }\n  accountByUuid(uuid: $uuid) @skip(if: $skipAccountByUuid) {\n    ...readCryptoAccountFragment\n    id\n  }\n  assetByUuid(uuid: $uuid) @skip(if: $skipAssetByUuid) {\n    asset {\n      latestPrice(quoteCurrency: $fiatCurrency) {\n        price\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b85fc3859ed97eb4f9671f2f5a96c926";

export default node;
